//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTimeline from "@/components/Generics/AQTimeline/AQTimeline.vue";
import { date } from "quasar";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import i18n from "@/i18n/index";

import { historyData } from "./dataHistory";

export default {
    name: "AQHistory",
    components: {
        AQCard,
        AQChip,
        AQButton,
        AQTimeline
    },
    props: {
        historyItems: { type: Array, required: true, default: () => [] },
        historyType: { type: String, required: true, default: () => "save" }, /* "save", "change"  */
        historyHasMoreItems: { type: Boolean, default: false }, // flag for pagination
        menuProps: { type: Array, default: () => [] },
        activeCommitIdTimeline: { type: String, default: "" }, // active commit id for timeline
        timelineKey: { type: Number, default: 0 },
        displayIt: { type: Boolean, default: true } // flag for displaying
    },
    data() {
        return {
            // eslint-disable-next-line global-require
            moreIcon: require("@/assets/images/Buttons/more.svg"),
            userType: "user",
            userDisabledType: "disabledUser",
            defaultItemType: "edit",
            defaultHistoryType: "save",
            publishHistoryType: "publish",
            renameHistoryType: "rename",
            deleteType: "delete",
            editType: "edit",
            historyCustomData: historyData()
        };
    },
    computed: {
        computedShowMoreLabel() {
            let labelShowMore = "";
            if (this.historyType === "save") {
                labelShowMore = this.$t("versioning.showOlderSaves");
            } else if (this.historyType === "change") {
                labelShowMore = this.$t("versioning.showOlderChanges");
            }
            return labelShowMore;
        }
    },

    methods: {
        actionNote(evt) {
            this.$emit("actionNote", evt);
        },
        menuClick(action) {
            if (action) {
                this.$emit("click", action);
            }
        },
        itemTimelineClicked(action) {
            if (action) {
                this.$emit("itemTimelineClick", action);
            }
        },
        showMoreItems(routeName) {
            if (this.historyType === "save") {
                this.$root.$emit("showMoreSaveHistory", routeName);
            } else if (this.historyType === "change") {
                this.$root.$emit("showMoreChangeHistory", routeName);
            }
        },
        itemIcon(itemType) {
            const historyObj = this.historyCustomData[this.historyType];
            const typeNow = Object.keys(historyObj).includes(itemType) ? itemType : this.defaultItemType;
            return historyObj[typeNow].icon;
        },
        menuHistoryItem(itemType, itemRecoverable) {
            const historyObj = this.historyCustomData[this.historyType];
            const typeNow = Object.keys(historyObj).includes(itemType) ? itemType : this.defaultItemType;
            const menuOptions = {
                options: [],
                popoverAnchorPosition: "bottom right",
                popoverSelfPosition: "top right",
                resetSelectedData: true
            };
            if (typeNow === this.deleteType && itemRecoverable) {
                menuOptions.options.push({ name: "recover", label: `${i18n.t("versioning.recover")}` });
            }
            return menuOptions.options.length ? menuOptions : null;
        },
        menuHistoryHeader(itemHistory) {
            if (itemHistory.actionDescription) {
                return itemHistory.actionDescription;
            }
            let resultTxt;
            const historyObj = this.historyCustomData[this.historyType];
            const typeNow = Object.keys(historyObj).includes(itemHistory.type) ? itemHistory.type : this.defaultItemType;
            if (itemHistory.type !== this.publishHistoryType) {
                resultTxt = `${(itemHistory.type === this.renameHistoryType)
                    ? `"<b>${itemHistory.elementOldName}</b>" ${historyObj[typeNow].verb} "<b>${itemHistory.elementName}</b>"`
                    : `"<b>${itemHistory.elementName}</b>" ${historyObj[typeNow].verb}`}`;
            } else {
                resultTxt = `${historyObj[typeNow].verb}`;
            }
            return resultTxt;
        },
        dateFormatter(dateToFormat, withTime) {
            let dateReturn = "";
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(".") : "";
            const data = new Date();
            data.setMonth(newData[1] - 1);
            const year = newData[2].split(" ")[0];
            const hour = newData[2].split(" ")[1].substring(0, 5);
            withTime = withTime ? ` ${i18n.t("versioning.at")} ${hour}` : "";
            if (localStorage.getItem("language") === "ro") {
                dateReturn = `${newData[0]} ${data.toLocaleString("ro-RO", { month: "long" })}, ${year}${withTime}`;
            } else {
                dateReturn = `${data.toLocaleString("en-US", { month: "long" })} ${newData[0]}, ${year}${withTime}`;
            }
            return dateReturn;
        },
        cardExpandState(itemHistoryType, itemHistoryEdits) {
            return (this.historyType !== this.defaultHistoryType)
                && ((itemHistoryType !== this.editType) || (itemHistoryType === this.editType && itemHistoryEdits.length === 1));
        },
        cardOpenState(itemHistory, itemIndex) {
            let currentOpenState = false;
            if (!this.activeCommitIdTimeline) {
                currentOpenState = this.historyType === this.defaultHistoryType && itemIndex === 0;
            } else {
                const activeCommitIdIndex = itemHistory.items.filter((currentItem) => currentItem.commitId === this.activeCommitIdTimeline).length;
                currentOpenState = !!activeCommitIdIndex;
            }
            return currentOpenState;
        },
        countPublishPoints(editArray) {
            return editArray.filter((currentItem) => currentItem.commitType === this.publishHistoryType).length;
        },
        menuHistoryAction(menuOptionClicked, historyItem) {
            this.$emit("menuItemClick", { menuOptionClicked, ...historyItem });
        }
    }
};
